import React from "react";
import { Rings } from 'react-loader-spinner'
const LoadingComponent = ({ isLoading = false }) => {
    return isLoading && (
        <div
            className="position-fixed top-0 start-0 end-0 bottom-0"
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 9999 
            }}
        >
            <Rings
                height="80"
                width="80"
                color="#6FCCDD"
                radius="6"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="rings-loading"
            />
        </div>
    );
};

export default LoadingComponent;
